/*
 * Root Saga
 */

import { authSagas } from "@app/modules/auth";
import { beAnInvestorSagas } from "@app/modules/beAnInvestor";
import { bootstrapSagas } from "@app/modules/bootstrap";
import { OrderSagas } from "@app/modules/buy";
import { brandSagas } from "@app/modules/categories";
import { contactUsSagas } from "@app/modules/footer";
import { userDashboardSagas } from "@app/modules/home";
import { myOrdersSagas } from "@app/modules/my-orders";
import { myProfileSagas } from "@app/modules/my-profile";
import { viewsSagas } from "@app/modules/product-detail";
import { usedCarsSagas } from "@app/modules/product-list-page";
import { sellCarSagas } from "@app/modules/sellCar";
import { testDriveSagas } from "@app/modules/test-drive-process";
import { wishlistSagas } from "@app/modules/wishlist";

const rootSaga: any[] = [
  authSagas,
  bootstrapSagas,
  OrderSagas,
  userDashboardSagas,
  brandSagas,
  usedCarsSagas,
  testDriveSagas,
  myProfileSagas,
  contactUsSagas,
  viewsSagas,
  wishlistSagas,
  sellCarSagas, 
  myOrdersSagas,
  beAnInvestorSagas
];

export { rootSaga };
